export default __webpack_public_path__ + "static/visa_master-ac0254793b835772c075f8d8597de9d5.png";